import React, { useState } from 'react';
import { Modal, Box, Button, Snackbar } from '@mui/material';
import CloseIcon from '../../../assets/svg/closeIcon';
import './CouponDetailsModal.css';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import img1 from '../../../assets/offersforyou1.png';
import starPic from '../../../assets/StarWhite.svg';

const CouponDetailsModal = ({ open = false, handleClose = () => {}, coupon}) => {
    const address = coupon?.vendorcoupon?.Address ? `${coupon?.vendorcoupon?.Address} ${coupon?.vendorcoupon?.city}, ${coupon?.vendorcoupon?.state}, ${coupon?.vendorcoupon?.country}, ${coupon?.vendorcoupon?.pincode}` : '';
    const { t } = useTranslation();
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    setTimeout(() => {
        setAnimateModal(true);
    }, 100);

    function getDate(isoString) {
        return new Date(isoString).toISOString().split('T')[0];
    }

    const handleCopy = () => {
        setOpenSnackbar(true);
    };

    const handleCloseCopy = () => {
        setOpenSnackbar(false);
    };
    return (
        <Modal
            open={open}
            onClose={() => {
                setClosing(true);
                handleClose();
            }}
            style={{
                backdropFilter: 'blur(10px)',
                backgroundColor: '#2C3142B2 !important',
            }}
        >
            <Box
                className={`offer-detail-popup ${animateModal ? 'animate' : ''} ${
                    closing ? 'close' : ''
                }`}
            >
                <div className='offer-image-container11'>
                    <div className='offer-img'>
                        <div className='image-overlay'>
                            <img
                                src={img1}
                                alt={coupon?.Coupon_code}
                                onError={(e) => {
                                    e.target.src = img1;
                                }}
                                className='image'
                            />
                        </div>
                    </div>
                    <div className='title-close-container'>
                        <CloseIcon
                            size={30}
                            color='white'
                            onClick={handleClose}
                            className='close-icon'
                        />
                    </div>
                    <div className='menu-item-offer-container' style={{top:'42%'}}>
                        <p className='menu-item1'>{coupon?.Title}</p>
                    </div>
                    <div className='img-rating-restaurant'>
                        <p className='rating-order'>
                            {coupon?.vendor?.avg_rating == 'N/A'
                                ? '0.0'
                                : Number(coupon?.vendor?.avg_rating || 0.0)?.toFixed(1)}
                        </p>
                        <img className='star-img-order' src={starPic} alt='star' />
                    </div>
                </div>

                <div className='coupon-details-container'>
                    <div className='address-container11'>
                        <div className='info-container2'>
                            <p className='info-text2'>{t('couponsDetails.Vendor_Name')}</p>
                            <span className='two-dot2'>:</span>
                            <p className='info-value2'>{coupon?.vendorcoupon?.Name}</p>
                        </div>
                        <div className='info-container2'>
                            <p className='info-text2'>{t('couponsDetails.Address')}</p>
                            <span className='two-dot2'>:</span>
                            <p className='info-value2'>{address}</p>
                        </div>
                        {coupon?.valid_from && (
                            <div className='info-container2'>
                                <p className='info-text2'>{t('couponsDetails.Valid_From')}</p>
                                <span className='two-dot2'>:</span>
                                <p className='info-value2'>{getDate(coupon?.valid_from)}</p>
                            </div>
                        )}
                        {coupon?.valid_to && (
                            <div className='info-container2'>
                                <p className='info-text2'>{t('couponsDetails.Valid_To')}</p>
                                <span className='two-dot2'>:</span>
                                <p className='info-value2'>{getDate(coupon?.valid_to)}</p>
                            </div>
                        )}
                        {!coupon?.valid_from && !coupon?.valid_to && (
                            <div className='info-container2'>
                                <p className='info-text2'>{t('couponsDetails.Validity')}</p>
                                <span className='two-dot2'>:</span>
                                <p className='info-value2'>{t('couponsDetails.No_Validity')}</p>
                            </div>
                        )}
                    </div>

                    <div className='info-container22'>
                        <p className='info-text22'>
                            {t('couponsDetails.Short_Description')} :
                        </p>
                        <p className='info-value22'>{coupon?.shortdescription}</p>
                    </div>

                    <div className='info-container22'>
                        <p className='info-text22'>{t('couponsDetails.Description')} :</p>
                        <p className='info-value22'>{coupon?.Description}</p>
                    </div>

                    <div className='limit-amount-container'>
                        <div className='info-container12'>
                            <p className='info-text12'>
                                {t('couponsDetails.Discount_Amount')} :
                            </p>
                            <p className='info-value12'>{coupon?.max_amount || 0}</p>
                        </div>
                        <div className='info-container12'>
                            <p className='info-text12'>{t('couponsDetails.Redeem_Limit')} :</p>
                            <p className='info-value12'>{coupon?.RedeemLimitCoupon || 0}</p>
                        </div>
                    </div>

                </div>
                <div className="copy-coupon-code-section">
                    <div className="coupon-detail-code">{coupon?.Coupon_code}</div>
                    <CopyToClipboard text={coupon?.Coupon_code} onCopy={handleCopy}>
                        <Button
                            variant="contained"
                            className="copy-button"
                        >
                Copy
                        </Button>
                    </CopyToClipboard>
                    <Snackbar 
                        open={openSnackbar}
                        autoHideDuration={2000}
                        onClose={handleCloseCopy}
                        message="Coupon code copied!"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        sx={{ '& .MuiSnackbarContent-root': { minWidth: '150px' } }}
                    />
                </div>
                
            </Box>
        </Modal>
    );
};

export default CouponDetailsModal;
